export default __webpack_public_path__ + "95b8edc283aaab8b9502aeef07d4c741.png";